class Patient {
  nik = "";
  name = "";
  last_name = "";
  sex = "";
  date = "";
  parent_name = "";
  birth_place = "";
  birth_date = "";
  address = "";
  village_id = "";
  education_id = "99";
  job_id = "99";
  religion_id = "";
  marital_status_id = "0";
  contact = "";
  photo = "";
  flag = "1";
  rekam_medis_flags = "1";
  parent_id = "1";
  patient_id = "";
  family_folder = "";
  family_relationship_id = "";
  paramedic_id = null;
  user_id = "";
  user_id_poli = "";
  payment_type_id = "";
  clinic_id = "";
  insurance_no = "";
  previous_clinic_id = "0";
  continue_id = "1";
  continue_to = "1";
  continue_internal = "0";
  served = "0";
  pcare_patient_code_provider = "";
  admission_type_id = "1";
  drug_taken = "0";
  specialis = "0";
  visit_type = "1";
  served_card = "0";
  clinic_group = "1";
  nurse_id = "1";
  kd_sadar = "01";
  kd_tacc = "1";
  pcare_visit_number = null;
  pcare_queue_number = null;
  statuscall = "0";
  statustracer = "0";
  flg_outdoor = "0";
  outdoor_visit_id = "0";
  ambulance = "0";
  flg_resume = "0";
  bloodId = "0";
  resume = "1";
  queue = "1";
  drug_queue = "0";
  pcare_sick = true;
  pcare_treatment_code = "10";
  domicile = "";
  jadwal = null;
  paramedic_schedule_code = null;

  constructor(patientData) {
    Object.keys(patientData)
      .filter((key) => key in this)
      .forEach((key) => {
        this[key] = patientData[key];
      });
  }
}

export default Patient;
